function formatarNumero(numero) {
    return numero.replace('.', ',').replace(',00', '');
}
export default (precos) => {
    let desconto = (parseFloat(precos.percpromocao)).toFixed(2)
    if (precos.promoqtapartirde > 0 && desconto > 0)
        return `Desconto de ${formatarNumero(desconto)}% a partir de ${formatarNumero(
            precos.promoqtapartirde
        )} unidades`
    else {
        if (desconto <= 0) return
        else return `${formatarNumero(desconto)}% de desconto`
    }
}